__turbopack_context__.v({
  "button": "style-module-scss-module__uCn0IG__button",
  "icon": "style-module-scss-module__uCn0IG__icon",
  "icon_search": "style-module-scss-module__uCn0IG__icon_search",
  "root": "style-module-scss-module__uCn0IG__root",
  "wrapper": "style-module-scss-module__uCn0IG__wrapper",
});
